var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseView',{attrs:{"is-loading":false,"load-error":!_vm.isUser},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('CardChangePassword',{attrs:{"card-title":`Reset Password`,"reset-password-user-uuid":_vm.userUuid}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }